<h1 mat-dialog-title *ngIf="transition.confirmationTitle">{{ transition.confirmationTitle }}</h1>

<div mat-dialog-content>
  <p *ngIf="transition.confirmationDescription">{{ transition.confirmationDescription }}</p>

  <!--
  <h3>Summary</h3>
  <ul>
    <li>Booking will be confirmed</li>
    <li>A seat will be reserved</li>
    <li>A payment request will be generated</li>
    <li>Confirmation email will be sent</li>
  </ul>
-->
</div>

<div mat-dialog-actions>
  <ub-button-list>
    <button mat-flat-button
            type="button"
            color="warn"
            [mat-dialog-close]="canceled">{{ transition.cancelButton ?? getDefaultCancelButtonTitle() }}</button>
    <button mat-flat-button
            type="submit"
            color="primary"
            [mat-dialog-close]="true"
            cdkFocusInitial>{{ transition.okButton ?? getDefaultOkButtonTitle() }}</button>
  </ub-button-list>
</div>
